export default "__VITE_ASSET__40arMSTF__"